// src/components/shared/GroupSelector.js
import React from "react";
import { Chip, Stack, Divider } from "@mui/material";
import { getGroupChips } from "./fantasyGroups";
import { trackFantasyAction } from "../../../../utils/analytics";

const GroupSelector = ({ useStarGroup, setUseStarGroup, selectedGroup, setSelectedGroup }) => {
  const groupChips = getGroupChips(useStarGroup);
  const selectedGroupsArray = Array.isArray(selectedGroup) ? selectedGroup : [selectedGroup];
  const isAllSelected = selectedGroupsArray.includes("All");

  const handleGroupToggle = (group) => {
    if (group === "All") {
      setSelectedGroup(["All"]);
      trackFantasyAction('group_selected', { group: "All", type: useStarGroup ? 'star' : 'open' });
      return;
    }

    let newSelection = [];
    if (isAllSelected) {
      newSelection = [group];
    } else {
      if (selectedGroupsArray.includes(group)) {
        newSelection = selectedGroupsArray.filter(g => g !== group);
        if (newSelection.length === 0) newSelection = ["All"];
      } else {
        newSelection = [...selectedGroupsArray, group];
        if (newSelection.length === groupChips.length) {
          newSelection = ["All"];
        }
      }
    }
    setSelectedGroup(newSelection);
    trackFantasyAction('group_selected', { group: newSelection.join(','), type: useStarGroup ? 'star' : 'open' });
  };

  return (
    <Stack direction="row" spacing={2} justifyContent="center" flexWrap="wrap" sx={{ mb: 3 }}>
        {/* Star/Open Toggle as dual chips */}
        <Stack direction="row" spacing={1} alignItems="center">
            <Chip
            label="Star"
            color={useStarGroup ? "primary" : "default"}
            variant={useStarGroup ? "filled" : "outlined"}
            onClick={() => {
              setUseStarGroup(true);
              trackFantasyAction('group_type_changed', { type: 'star' });
            }}
            clickable
            />
            <Chip
            label="Open"
            color={!useStarGroup ? "primary" : "default"}
            variant={!useStarGroup ? "filled" : "outlined"}
            onClick={() => {
              setUseStarGroup(false);
              trackFantasyAction('group_type_changed', { type: 'open' });
            }}
            clickable
            />
        </Stack>

        {/* Divider */}
        <Divider orientation="vertical" flexItem sx={{ mx: 1, borderColor: "#ccc" }} />

        {/* Group Chips */}
        {groupChips.map((group) => (
            <Chip
            key={group}
            label={group}
            color={selectedGroupsArray.includes(group) && !isAllSelected ? "secondary" : "default"}
            onClick={() => handleGroupToggle(group)}
            clickable
            />
        ))}

        {/* "All" Group */}
        <Chip
            label="All"
            color={isAllSelected ? "secondary" : "default"}
            variant={isAllSelected ? "filled" : "outlined"}
            onClick={() => handleGroupToggle("All")}
            clickable
            sx={{ ml: 1 }}
        />
        </Stack>

  );
};

export default GroupSelector;
